module.exports = __webpack_public_path__ + "img/MTCIFINS.3df01b11.png";